import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'
import moment from 'moment'

// State
export const state = {
  salesRepresentatives: [],
  customers: [],
  ncReasons: [],
  partNumbers: [],
  blanketStatuses: [],
  voucherStatuses: [],
  termsDescription: [],
  deliverySlip: [],
  purchaseOrders: [],
  partnerStores: [],
  countries: [],
  provinces: [],
  invoiceTypes: [],
  stockLocations: [],
  allowedStockLocations: [],
  operations: [],
  methods: [],
  products: [],
  companyProducts: [],
  allowedCompanyProducts: [],
  specialOperations: [],
  workOrderReferences: [],
  salesOrders: [],
  termsWithZeroOffset: [],
  term: {},
  poSpecialCases: [],
  transitTerms: [],
  shippers: [],
  terms: [],
  externalOperations: [],
  catCodes: [],
  purchaseOrderStatuses: [],
  vendors: [],
  unitOfMeasures: [],
  references: [],
  partNumbersComponents: [],
  reasonsForVendorReturn: [],
  reasonsForRGA: [],
  coRgaStatuses: [],
  coRgaList: [],
  allPurchaseOrders: [],
  deliverySlipByPO: [],
  itemsForReturn: [],
  salesOrderInvoiceStatuses: [],
  salesOrderStatuses: [],
  workOrders: [],
  companyWorkOrders: [],
  workOrderStatuses: [],
  partners: [],
  reports: [],
  buyerPlanners: [],
  customerPurchaseOrders: []
}

// Getters
export const getters = {
  salesRepresentatives: state => state.salesRepresentatives,
  customers: state => state.customers,
  blanketStatuses: state => state.blanketStatuses,
  ncReasons: state => state.ncReasons,
  partNumbers: state => state.partNumbers,
  voucherStatuses: state => state.voucherStatuses,
  termsDescription: state => state.termsDescription,
  deliverySlip: state => state.deliverySlip,
  purchaseOrders: state => state.purchaseOrders,
  partnerStores: state => state.partnerStores,
  countries: state => state.countries,
  provinces: state => state.provinces,
  salesOrders: state => state.salesOrders,
  poSpecialCases: state => state.poSpecialCases,
  invoiceTypes: state => state.invoiceTypes,
  stockLocations: state => state.stockLocations,
  allowedStockLocations: state => state.allowedStockLocations,
  operations: state => state.operations,
  methods: state => state.methods,
  products: state => state.products,
  companyProducts: state => state.companyProducts,
  allowedCompanyProducts: state => state.allowedCompanyProducts,
  specialOperations: state => state.specialOperations,
  workOrderReferences: state => state.workOrderReferences,
  termsWithZeroOffset: state => state.termsWithZeroOffset,
  term: state => state.term,
  externalOperations: state => state.externalOperations,
  transitTerms: state => state.transitTerms,
  shippers: state => state.shippers,
  terms: state => state.terms,
  catCodes: state => state.catCodes,
  purchaseOrderStatuses: state => state.purchaseOrderStatuses,
  vendors: state => state.vendors,
  unitOfMeasures: state => state.unitOfMeasures,
  references: state => state.references,
  partNumbersComponents: state => state.partNumbersComponents,
  reasonsForVendorReturn: state => state.reasonsForVendorReturn,
  reasonsForRGA: state => state.reasonsForRGA,
  coRgaStatuses: state => state.coRgaStatuses,
  coRgaList: state => state.coRgaList,
  allPurchaseOrders: state => state.allPurchaseOrders,
  deliverySlipByPO: state => state.deliverySlipByPO,
  itemsForReturn: state => state.itemsForReturn,
  salesOrderInvoiceStatuses: state => state.salesOrderInvoiceStatuses,
  salesOrderStatuses: state => state.salesOrderStatuses,
  workOrders: state => state.workOrders,
  companyWorkOrders: state => state.companyWorkOrders,
  workOrderStatuses: state => state.workOrderStatuses,
  partners: state => state.partners,
  reports: state => state.reports,
  buyerPlanners: state => state.buyerPlanners,
  customerPurchaseOrders: state => state.customerPurchaseOrders
}

// Mutations
export const mutations = {
  SALES_REPRESENTATIVES (state, data) {
    state.salesRepresentatives = data
  },

  CUSTOMERS (state, data) {
    state.customers = data
  },

  BLANKET_STATUSES (state, data) {
    state.blanketStatuses = data
  },

  NCREASONS (state, data) {
    state.ncReasons = data
  },

  PART_NUMBERS (state, data) {
    state.partNumbers = data
  },

  VOUCHER_STATUSES (state, data) {
    state.voucherStatuses = data
  },

  TERMS_DESCRIPTION (state, data) {
    state.termsDescription = data
  },

  DELIVERY_SLIP (state, data) {
    state.deliverySlip = data
  },

  PURCHASE_ORDER (state, data) {
    state.purchaseOrders = data
  },

  PARTNER_STORES (state, data) {
    state.partnerStores = data
  },

  COUNTRIES (state, data) {
    state.countries = data
  },

  PROVINCES (state, data) {
    state.provinces = data
  },

  SALES_ORDERS (state, data) {
    state.salesOrders = data
  },

  PO_SPECIAL_CASES (state, data) {
    state.poSpecialCases = data
  },

  STOCK_LOCATIONS (state, data) {
    state.stockLocations = data
  },

  ALLOWED_STOCK_LOCATIONS (state, data) {
    state.allowedStockLocations = data
  },

  INVOICE_TYPES (state, data) {
    state.invoiceTypes = data
  },

  OPERATIONS (state, data) {
    state.operations = data
  },

  METHODS (state, data) {
    state.methods = data
  },

  PRODUCTS (state, data) {
    state.products = data
  },

  COMPANY_PRODUCTS (state, data) {
    state.companyProducts = data
  },

  ALLOWED_COMPANY_PRODUCTS (state, data) {
    state.allowedCompanyProducts = data
  },

  SPECIAL_OPERATIONS (state, data) {
    state.specialOperations = data
  },

  WORK_ORDER_REFERENCES (state, data) {
    state.workOrderReferences = data
  },

  TERMS_WITH_ZERO_OFFSET (state, data) {
    state.termsWithZeroOffset = data
  },

  TERM (state, data) {
    state.term = data
  },

  CAT_CODES (state, data) {
    state.catCodes = data
  },

  EXTERNAL_OPERATIONS (state, data) {
    state.externalOperations = data
  },

  TERMS (state, data) {
    state.terms = data
  },

  TRANSIT_TERMS (state, data) {
    state.transitTerms = data
  },

  SHIPPERS (state, data) {
    state.shippers = data
  },

  PURCHASE_ORDER_STATUSES (state, data) {
    state.purchaseOrderStatuses = data
  },

  VENDORS (state, data) {
    state.vendors = data
  },

  UNIT_OF_MEASURES (state, data) {
    state.unitOfMeasures = data
  },

  REFERENCES (state, data) {
    state.references = data
  },

  PART_NUMBERS_COMPONENTS (state, data) {
    state.partNumbersComponents = data
  },

  REASONS_FOR_VENDOR_RETURN (state, data) {
    state.reasonsForVendorReturn = data
  },

  REASONS_FOR_RGA (state, data) {
    state.reasonsForRGA = data
  },

  CO_RGA_STATUSES (state, data) {
    state.coRgaStatuses = data
  },

  CO_RGA_LIST (state, data) {
    state.coRgaList = data
  },

  ALL_PURCHASE_ORDERS (state, data) {
    state.allPurchaseOrders = data
  },

  DELIVERY_SLIP_BY_PO (state, data) {
    state.deliverySlipByPO = data
  },

  SO_INVOICE_STATUSES (state, data) {
    state.salesOrderInvoiceStatuses = data
  },

  SALES_ORDER_STATUSES (state, data) {
    state.salesOrderStatuses = data
  },

  WORK_ORDERS (state, data) {
    state.workOrders = data
  },

  COMPANY_WORK_ORDERS (state, data) {
    state.companyWorkOrders = data
  },

  WORK_ORDER_STATUSES (state, data) {
    state.workOrderStatuses = data
  },

  PARTNERS (state, data) {
    state.partners = data
  },

  REPORTS (state, data) {
    state.reports = data
  },

  BUYER_PLANNERS (state, data) {
    state.buyerPlanners = data
  },

  CUSTOMER_PURCHASE_ORDERS (state, data) {
    state.customerPurchaseOrders = data
  }

}

// Actions
export const actions = {
  async searchSalesRep ({ commit }, searchValue) {
    const { data } = await axios.get(laroute.route('search_users_initials'))

    commit('SALES_REPRESENTATIVES', data)
  },

  async searchCustomers ({ commit }, searchValue) {
    const { data } = await axios.get(laroute.route('customers_list', { searchValue }))

    commit('CUSTOMERS', data)
  },

  async searchVendors ({ commit }, searchValue) {
    const { data } = await axios.get(laroute.route('search_vendors', { searchValue }))

    commit('VENDORS', data)
  },

  async searchBlanketStatuses ({ commit }) {
    const { data } = await axios.get(laroute.route('get_blanket_statuses'))
    commit('BLANKET_STATUSES', data)
  },

  async searchNcReasons ({ commit }) {
    const { data } = await axios.get(laroute.route('no-charge-reason-list'))

    commit('NCREASONS', data)
  },

  async searchPartNumbers ({ commit }, { itemMasterID, searchValue = '', showGroup = true }) {
    const { data } = await axios.get(laroute.route('search_part_numbers',
      { companyAbbr: store.getters['auth/company'], itemMasterID, searchValue, showGroup }))

    commit('PART_NUMBERS', data)
  },

  async searchPartNumbersByIds ({ commit }, ids) {
    if (ids.length > 0) {
      const { data } = await axios.get(laroute.route('search_part_numbers_by_ids', {
        companyAbbr: store.getters['auth/company'],
        ids
      }))

      const onHand = await axios.get(laroute.route('get_vendor_return_items_on_hand', { companyAbbr: store.getters['auth/company'], ids }))

      onHand.data.data.filter((element) => {
        data.filter((item, index, array) => {
          if (item.item_master_id === element.item_master_id) {
            array[index].on_hand = element.qty ? element.qty : 0
          }
        })
      })

      commit('PART_NUMBERS', data)
    }
  },

  async searchVoucherStatuses ({ commit }) {
    const { data } = await axios.get(laroute.route('get_voucher_statuses'))
    commit('VOUCHER_STATUSES', data)
  },

  async searchTermsDescription ({ commit }) {
    const { data } = await axios.get(laroute.route('get_terms_description'))
    commit('TERMS_DESCRIPTION', data)
  },

  async searchTermsWithZeroOffset ({ commit }) {
    const { data } = await axios.get(laroute.route('get-terms-with-zero-offset'))

    commit('TERMS_WITH_ZERO_OFFSET', data)
  },

  async searchDeliverySlip ({ commit }, { purchaseOrderId }) {
    const { data } = await axios.get(laroute.route('get_delivery_slip_list', { purchaseOrderId: purchaseOrderId }))
    commit('DELIVERY_SLIP', data)
  },

  async searchPurchaseOrders ({ commit }, { searchValue }) {
    const { data } = await axios.get(laroute.route('purchase_order_list',
      { companyAbbr: store.getters['auth/company'], searchValue })
    )
    commit('PURCHASE_ORDER', data)
  },

  async searchDeliverySlipByPO ({ commit }, { purchaseOrderId }) {
    const { data } = await axios.get(laroute.route('get_delivery_slip_by_po_list', { purchaseOrderId: purchaseOrderId }))
    commit('DELIVERY_SLIP_BY_PO', data)
  },

  async searchAllPurchaseOrders ({ commit }, { search }) {
    const { data } = await axios.get(laroute.route('all_purchase_orders_list', { search }))
    commit('ALL_PURCHASE_ORDERS', data)
  },

  async searchPartnerStores ({ commit }, { id, searchValue = '' }) {
    const { data } = await axios.get(laroute.route('get-partner-stores', { id, searchValue }))

    commit('PARTNER_STORES', data)
  },

  async searchCountries ({ commit }, searchValue = '') {
    const { data } = await axios.get(laroute.route('countries_list', { searchValue }))

    commit('COUNTRIES', data)
  },

  async searchProvinces ({ commit }, id, searchValue = '') {
    const { data } = await axios.get(laroute.route('get_provinces', { id }))

    commit('PROVINCES', data)
  },

  async getActiveSalesOrders ({ commit }) {
    const { data } = await axios.get(laroute.route('sales_orders_list', {
      companyAbbr: store.getters['auth/company']
    }))
    commit('SALES_ORDERS', data)
  },

  async getPOSpecialCases ({ commit }) {
    const { data } = await axios.get(laroute.route('po_special_cases_list'))

    commit('PO_SPECIAL_CASES', data)
  },

  async searchAllPartnerStores ({ commit }, { searchValue, partnerId }) {
    const { data } = await axios.get(laroute.route('get_partner_stores_addresses', { searchValue, partnerId }))

    commit('PARTNER_STORES', data)
  },

  async searchStockLocations ({ commit }, searchValue) {
    const { data } = await axios.get(laroute.route('get-stock-locations',
      { companyAbbr: store.getters['auth/company'], searchValue }))

    commit('STOCK_LOCATIONS', data)
  },

  async getAllowedStockLocations ({ commit }, ids) {
    const { data } = await axios.get(laroute.route('get-allowed-stock-locations',
      { companyAbbr: store.getters['auth/company'], ids }))

    commit('ALLOWED_STOCK_LOCATIONS', data)
  },

  async searchCatCodes ({ commit }, searchValue) {
    const { data } = await axios.get(laroute.route('get-cat-codes',
      { companyAbbr: store.getters['auth/company'], searchValue }))
    commit('CAT_CODES', data)
  },

  async getInvoiceTypes ({ commit }) {
    const { data } = await axios.get(laroute.route('get-invoice-types'))

    commit('INVOICE_TYPES', data)
  },

  async searchOperations ({ commit }, searchValue) {
    const { data } = await axios.get(laroute.route('get-operations',
      { companyAbbr: store.getters['auth/company'], searchValue }))

    commit('OPERATIONS', data.data)
  },

  async searchMethods ({ commit }, operationId) {
    const { data } = await axios.get(laroute.route('get-methods', { operationId }))

    commit('METHODS', data.data)
  },

  async getProducts ({ commit }, searchValue) {
    const { data } = await axios.get(laroute.route('get-products', { companyAbbr: store.getters['auth/company'], searchValue }))

    commit('PRODUCTS', data)
  },

  async getCompanyProducts ({ commit }, searchValue) {
    const { data } = await axios.get(laroute.route('get-company-products', { companyAbbr: store.getters['auth/company'], searchValue }))

    commit('COMPANY_PRODUCTS', data)
  },

  async getAllowedCompanyProducts ({ commit }, ids) {
    const { data } = await axios.get(laroute.route('get-allowed-company-products', { companyAbbr: store.getters['auth/company'], ids }))

    commit('ALLOWED_COMPANY_PRODUCTS', data)
  },

  async getProductsWithDetails ({ commit }, searchValue) {
    const { data } = await axios.get(laroute.route('get-products-with-details',
      { companyAbbr: store.getters['auth/company'], searchValue }))

    commit('PRODUCTS', data)
  },

  async getSpecialOperations ({ commit }) {
    const { data } = await axios.get(laroute.route('get-special-operations',
      { companyAbbr: store.getters['auth/company'] }))

    commit('SPECIAL_OPERATIONS', data.data)
  },

  async getAllProducts ({ commit }, searchValue) {
    const { data } = await axios.get(laroute.route('get-all-products', { companyAbbr: store.getters['auth/company'], searchValue }))

    commit('PRODUCTS', data)
  },

  async getWorkOrderReferences ({ commit }) {
    const { data } = await axios.get(laroute.route('get-wo-references',
      { companyAbbr: store.getters['auth/company'] }))

    commit('WORK_ORDER_REFERENCES', data)
  },

  async getOrdersForWorkOrders ({ commit }) {
    await axios.get(laroute.route('get-so-for-wo',
      { companyAbbr: store.getters['auth/company'] }))
      .then((res) => {
        res.data.map((so) => {
          so.due_date = moment(so.due_date).format('YYYY-MM-DD')
        })
        commit('SALES_ORDERS', res.data)
      })
  },

  async getTransitTerms ({ commit }) {
    await axios.get(laroute.route('get-transit-terms'))
      .then((res) => {
        commit('TRANSIT_TERMS', res.data)
      })
  },

  async getShippers ({ commit }) {
    await axios.get(laroute.route('get-shippers'))
      .then((res) => {
        commit('SHIPPERS', res.data)
      })
  },

  async getTerms ({ commit }) {
    await axios.get(laroute.route('terms_list'))
      .then((res) => {
        commit('TERMS', res.data)
      })
  },

  async getExternalOperations ({ commit }) {
    const { data } = await axios.get(laroute.route('get-external-operations',
      { companyAbbr: store.getters['auth/company'] }))

    commit('EXTERNAL_OPERATIONS', data.data)
  },

  async getSalesOrdersList ({ commit }, itemMasterId) {
    await axios.get(laroute.route('get-so-by-item-master',
      { companyAbbr: store.getters['auth/company'], itemMasterId }))
      .then((res) => {
        res.data.map((so) => {
          so.due_date = moment(so.due_date.date).format('YYYY-MM-DD')
        })
        commit('SALES_ORDERS', res.data)
      })
  },

  async searchPurchaseOrderStatuses ({ commit }) {
    const { data } = await axios.get(laroute.route('purchase_order_statuses_list'))

    commit('PURCHASE_ORDER_STATUSES', data)
  },

  async searchUnitOfMeasures ({ commit }) {
    const { data } = await axios.get(laroute.route('get-unit-of-measures-list'))

    commit('UNIT_OF_MEASURES', data)
  },

  async getReferences ({ commit }) {
    const { data } = await axios.get(laroute.route('get-references'))

    commit('REFERENCES', data)
  },

  async searchPartNumbersComponents ({ commit }, { itemMasterID, searchValue, parentId }) {
    const { data } = await axios.get(laroute.route('search-part-numbers-components',
      { companyAbbr: store.getters['auth/company'], itemMasterID, searchValue, parentId }))

    commit('PART_NUMBERS_COMPONENTS', data)
  },

  async getReasonsForVendorReturn ({ commit }, searchValue) {
    const data = await axios.get(laroute.route('get-reasons-for-vendor-return', searchValue))

    commit('REASONS_FOR_VENDOR_RETURN', data.data)
  },

  async getSalesOrderInvoiceStatuses ({ commit }) {
    const { data } = await axios.get(laroute.route('get-so-invoice-statuses'))

    commit('SO_INVOICE_STATUSES', data)
  },

  async getSalesOrderStatuses ({ commit }) {
    const { data } = await axios.get(laroute.route('get-sales-order-statuses'))

    commit('SALES_ORDER_STATUSES', data)
  },

  async getReasonsForRGA ({ commit }, searchValue) {
    const data = await axios.get(laroute.route('customer_return_reasons_list', searchValue))

    commit('REASONS_FOR_RGA', data.data)
  },

  async getCoRgaStatuses ({ commit }) {
    const data = await axios.get(laroute.route('get-co-rga-statuses'))

    commit('CO_RGA_STATUSES', data.data)
  },

  async getCoRgaList ({ commit }, { dataType }) {
    const data = await axios.get(laroute.route('get-co-rga-list', { companyAbbr: store.getters['auth/company'], dataType }))

    commit('CO_RGA_LIST', data.data)
  },

  async getWorkOrdersByPartNumber ({ commit }, { partNumberId, isClosed }) {
    const { data } = await axios.get(laroute.route('get-work-orders-by-part-number',
      { companyAbbr: store.getters['auth/company'], partNumberId, isClosed }))

    commit('WORK_ORDERS', data)
  },

  async getCompanyWorkOrders ({ commit }) {
    const { data } = await axios.get(laroute.route('get-company-work-orders', { companyAbbr: store.getters['auth/company'] }))
    commit('COMPANY_WORK_ORDERS', data)
  },

  async searchWorkOrderStatuses ({ commit }) {
    const { data } = await axios.get(laroute.route('get-work-orders-statuses'))

    commit('WORK_ORDER_STATUSES', data)
  },

  async searchPartners ({ commit }, searchValue) {
    const { data } = await axios.get(laroute.route('get-partners-list', searchValue))

    commit('PARTNERS', data)
  },

  async getReports ({ commit }, { type }) {
    const { data } = await axios.get(laroute.route('get-reports', { type }))

    commit('REPORTS', data)
  },

  async searchBuyerPlanners ({ commit }) {
    await axios.get('/api/buyer-planner/list').then(response => {
      commit('BUYER_PLANNERS', response.data)
    })
  },

  async getCustomerPurchaseOrders ({ commit }) {
    const { data } = await axios.get(laroute.route('get-customer-purchase-orders'))

    commit('CUSTOMER_PURCHASE_ORDERS', data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/filterData.js